import { Location } from '@eo-storefronts/eo-core'
import { Box } from '@mui/material'
import SuggestedItems from '~/src/components/marketplace/suggestions/suggested-items'
import Title from '~/src/components/mui-wrappers/Title'
import { useEoValue } from '~/src/hooks/useEoState'
import { useTranslations } from '~/src/hooks/useTranslations'
import { MARKETPLACE_SUGGESTED_LOCATIONS_STATE } from '~/src/stores/marketplace/suggestions'

const SuggestedLocations = () => {
  const { t } = useTranslations()
  const items: Location[] = useEoValue(MARKETPLACE_SUGGESTED_LOCATIONS_STATE)

  if (!items?.length) {
    return null
  }

  return (
    <Box>
      <Title
        variant='h5'
        sx={{
          fontWeight: 'normal',
          mb: 2
        }}
      >
        {t('explorer.suggestions')}
      </Title>

      <SuggestedItems items={items} />
    </Box>
  )
}

export default SuggestedLocations
